import { render, staticRenderFns } from "./ItemBranchStore.vue?vue&type=template&id=61c7f404&scoped=true"
import script from "./ItemBranchStore.vue?vue&type=script&lang=js"
export * from "./ItemBranchStore.vue?vue&type=script&lang=js"
import style0 from "./ItemBranchStore.vue?vue&type=style&index=0&id=61c7f404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c7f404",
  null
  
)

export default component.exports